export const heroObj = {
  headline: "Everyday payments using fingerprints. ",
  description:
    "Rediscover your cashless experiences. Use your fingerprint to just pay and go wherever Paythumb is accepted. No need of your phone, wallet or card.",
  imgStart: true,
  img: require("../../Assets/Images/Hands-pt.png").default,
  alt: "hero-section-phone",
};
